<div class="ui-g loyalty-cluster" *ngIf="render.datatable">
  <div class="ui-g-12" >

    <app-kontable #table data-testid="table" title = "{{ 'self_scan_service_detail.title' | translate }}"
                  [columns] = "['id', 'division_name', 'store_name',
                  { field: 'trx_date', filterTemplate: noFilter, filterType: noFilter, title: 'self_scan_service_detail.trx_date', bodyTemplate: dateTemplateBirth },
                  'card_id', 'term_id', 'trx_num','last_chk_chance','curr_chk_chance','flg_chk_result','rmnd_val'

                    ]"
                  [titles] = "['common.id', 'self_scan_service_detail.division_id', 'self_scan_service_detail.store_id', 'self_scan_service_detail.card_id','self_scan_service_detail.term_id','self_scan_service_detail.trx_num','self_scan_service_detail.last_chk_chance','self_scan_service_detail.curr_chk_chance','self_scan_service_detail.flg_chk_result','self_scan_service_detail.rmnd_val']"
                  [paginationType]="serverPagination"
                  [showInfoButton]="false"
                  [showGlobalFilter]="false"
                  [showDetailsButton]="true"
                  [showAddButton]="false"
                  [toolbarCustomButtons]="customButton"
                  [showEditButton]="false"
                  [showDeleteButton]="false"
                  [showRecoverButton]="false"
                  [service]="selfscanServiceDetail"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  [fixedFilters]="initialFilters"
                  (onDetails)="onOpen($event)"
    >

      <ng-template #dateTemplateBirth data-testid="dateTemplateBirth" let-row>
        <span>{{ row['trx_date'] }} {{ row['time_trx'].substring(0,5) }}</span>
      </ng-template>


      <ng-template #noFilter data-testid="noFilter" let-col>

      </ng-template>

      <ng-template #customButton>
        <button pButton type="button" class="k-generic-btn ui-button-icon-left" icon="fa fa-arrow-left" iconPos="left" label="{{ 'common.back' | translate }}"
                (click)="goBack()" style="margin-top: 7px; margin-left: 10px; height: 34px !important;"></button>
      </ng-template>



    </app-kontable>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-service-detail/loyalty-self-scan-service-detail.component.html